// @flow
import { Link } from 'gatsby'
import * as React from 'react'

import { Responsive } from '@toggl/ui'

import { Careers } from './Careers'
import { GlobalProducts } from './GlobalProducts'
import { Product } from './Product'
import { WhyTrack } from './WhyTrack'

export function TrackHeaderContents() {
  return (
    <React.Fragment>
      <GlobalProducts />
      <Product />
      <li>
        <Link to={'/track/pricing/'}>Pricing</Link>
      </li>
      <WhyTrack />
      <Careers />
      <Responsive.MobileOnly>
        <li>
          <Link to={'/track/demo-request/?source=header'}>Book a demo</Link>
        </li>
      </Responsive.MobileOnly>
    </React.Fragment>
  )
}
